import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const menuItems = [
  { caption: 'Solutions', url: '/solutions' },
  { caption: 'Products', url: '/products' },
  { caption: 'Consultancy', url: '/consultancy' },
  { caption: 'Support', url: '/support' },
  { caption: 'Company', url: '/company' },
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const isActive = (url) => {
    return location.pathname === url || location.pathname === url.slice(0, -1);
  };

  return (
    <nav 
      className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}
      role="navigation" 
      aria-label="Main Navigation"
    >
      <div className="container navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-brand" aria-label="SMART-WARES Home">
          <span className="logo-icon">SW</span>
          <span className="logo-text">SMART-WARES</span>
        </Link>

        {/* Mobile Menu Toggle */}
        <button 
          className="navbar-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMenuOpen}
          aria-controls="navbar-menu"
        >
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Navigation Menu */}
        <div 
          id="navbar-menu"
          className={`navbar-menu ${isMenuOpen ? 'is-open' : ''}`}
        >
          <ul className="navbar-nav">
            {menuItems.map((item) => (
              <li key={item.url} className="nav-item">
                <Link 
                  to={item.url}
                  className={`nav-link ${isActive(item.url) ? 'active' : ''}`}
                  aria-current={isActive(item.url) ? 'page' : undefined}
                >
                  {item.caption}
                </Link>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <Link to="/contact/" className="button button-primary navbar-cta">
            Contact Us
          </Link>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isMenuOpen && (
        <div 
          className="navbar-overlay"
          onClick={() => setIsMenuOpen(false)}
          aria-hidden="true"
        />
      )}
    </nav>
  );
}

export default Navbar;
